<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return { 
    };
  },
  mounted() {
	this.Rem();
    window.addEventListener("load", this.Rem);
    window.addEventListener("resize", this.Rem);
  },
  methods: {
    Rem() {
      // 表示1920的设计图,使用100PX的默认值
      var whdef = 100 / 750;
      // 当前窗口的宽度
      var bodyWidth = document.body.clientWidth;
      // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
      var rem = bodyWidth * whdef;
      document.getElementsByTagName("html")[0].style.fontSize = rem + "px";
    },
  },
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
</style>
